import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'

interface CodeValidProps {
    voucherCode: string
}

const VoucherPartialPaid = ({ voucherCode }: CodeValidProps) => (
    <FormattedMessage
        id="vouchers.discount.application_confirmation_partially"
        defaultMessage="Voucher <voucher></voucher> pokryje część zamówienia. <break>Pozostałą kwotę uregulujesz w następnym kroku.</break>"
        values={{
            voucher: () => (
                <>
                    {!!voucherCode && (
                        <Text as="span" variant="bodyStrong" color="success">
                            {` ${voucherCode}`}
                        </Text>
                    )}
                </>
            ),
            break: (chunks: string[]) => (
                <>
                    <br />
                    {chunks}
                </>
            ),
        }}
    />
)

export default VoucherPartialPaid
